module.exports = __webpack_public_path__ + "static/media/pawna.d89b96d3.jpg";